import * as React from "react";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import ContentCut from "@mui/icons-material/ContentCut";
import ContentCopy from "@mui/icons-material/ContentCopy";
import ContentPaste from "@mui/icons-material/ContentPaste";
import Cloud from "@mui/icons-material/Cloud";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { ASSETS } from "../../utils/config";

export default function IconMenu({
  onEdit = () => {},
  toggleMenu = () => {},
  isEditable,
}) {
  return (
    <Paper
      elevation={6}
      sx={{ minWidth: 140, maxWidth: "100%", borderRadius: "10px" }}
    >
      <MenuList>
        {isEditable ? (
          <MenuItem
            onClick={(event) => {
              event.stopPropagation(); // Stops the event from propagating further
              onEdit();
            }}
          >
            <ListItemIcon>
              <ModeEditOutlinedIcon
                sx={{ color: "#BBBBBB" }}
                ml={-4}
                fontSize="small"
              />
            </ListItemIcon>
            <ListItemText sx={{ color: "#565556", ml: -1, mr: 2 }}>
              Edit Segment
            </ListItemText>
          </MenuItem>
        ) : (
          <MenuItem
            onClick={(event) => {
              event.stopPropagation(); // Stops the event from propagating further
            }}
          >
            <ListItemIcon>
              <img src={ASSETS.clone} />
            </ListItemIcon>
            <ListItemText sx={{ color: "#565556", ml: -1, mr: 2 }}>
              Clone Segment
            </ListItemText>
          </MenuItem>
        )}
        {/* <MenuItem>
          <ListItemIcon>
            <DeleteOutlineOutlinedIcon
              sx={{ color: "#BBBBBB" }}
              fontSize="small"
            />
          </ListItemIcon>
          <ListItemText sx={{ color: "#565556" }}>Delete Segment</ListItemText>
        </MenuItem> */}
      </MenuList>
    </Paper>
  );
}
